const Team = () => {
  return (
    <div className="p-6 bg-white rounded-lg shadow-md min-h-[80vh]">
      <h2 className="text-2xl font-bold mb-4 text-green-600">Team Members</h2>
      <p>View and manage your team members.</p>
      <ul className="mt-4 space-y-2 text-gray-700">
        <li>John Doe - Software Engineer</li>
        <li>Jane Smith - QA Engineer</li>
        <li>Michael Brown - Designer</li>
      </ul>
    </div>
  );
};

export default Team;
